import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "navbar__nav" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }

import {useI18n} from "vue3-i18n";
import {onMounted, ref} from "vue";
import {IFullOrganization} from "@/types/entities/organization";
import i18n from "@/i18n";
import {useOrganizationService} from "@/inversify.config";


export default /*#__PURE__*/_defineComponent({
  __name: 'IndividualAndSyndicateCoownerMemberNavbarItems',
  setup(__props) {

const {t} = useI18n()

const organizationService = useOrganizationService()

const organization = ref<IFullOrganization>()

onMounted(async () => {
  let fullOrganization = await organizationService.getMyOrganization(i18n.getLocale())
  if (fullOrganization) {
    organization.value = fullOrganization
  }
})

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    _createElementVNode("li", null, [
      _createVNode(_component_RouterLink, {
        to: _unref(t)('routes.account.path'),
        class: "navbar__navlink"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('routes.account.name')), 1)
        ]),
        _: 1
      }, 8, ["to"])
    ]),
    _createElementVNode("li", null, [
      _createVNode(_component_RouterLink, {
        to: _unref(t)('routes.coproperty.path'),
        class: "navbar__navlink"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('routes.coproperty.name')), 1)
        ]),
        _: 1
      }, 8, ["to"])
    ]),
    (organization.value?.subscription.isActive)
      ? (_openBlock(), _createElementBlock("li", _hoisted_2, [
          _createVNode(_component_RouterLink, {
            to: _unref(t)('routes.membership.path'),
            class: "navbar__navlink"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('routes.membership.name')), 1)
            ]),
            _: 1
          }, 8, ["to"])
        ]))
      : _createCommentVNode("", true),
    (organization.value?.syndicate?.isActive)
      ? (_openBlock(), _createElementBlock("li", _hoisted_3, [
          _createVNode(_component_RouterLink, {
            to: _unref(t)('routes.syndicate.path'),
            class: "navbar__navlink"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('routes.syndicate.name')), 1)
            ]),
            _: 1
          }, 8, ["to"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("li", null, [
      _createVNode(_component_RouterLink, {
        to: _unref(t)('routes.invoices.path'),
        class: "navbar__navlink"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('routes.invoices.name')), 1)
        ]),
        _: 1
      }, 8, ["to"])
    ]),
    _createElementVNode("li", null, [
      _createVNode(_component_RouterLink, {
        to: _unref(t)('routes.activities.path'),
        class: "navbar__navlink"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('routes.activities.name')), 1)
        ]),
        _: 1
      }, 8, ["to"])
    ])
  ]))
}
}

})